import moment from "moment/moment";
import _ from "lodash";
import {generateFetchFieldListAction} from "../../../../apps/KpModule/actions/api";

export const entity = {
    name: 'Action',
    facets: ['conversations'],
    fields: [
        { path: 'name', unique: true },
        'Project',
        { path: 'type', type: 'ActionType' },
        { path: 'creation', type: 'date', nullable: true },
        { path: 'update', type: 'date', nullable: true },
        { type: 'User', nullable: true },
        { path: 'deadline', type: 'date'},
        { path: 'responsible', type: 'User' },
        'description',
        { path: 'status', type: 'ActionStatus' },
        { path: 'priority', type: 'Influence'},
        { path: 'state', type: 'Status'},
        {path: 'numberOfRevisions', type: 'integer', default: 0}
    ],
    beforeSave: function(newObject, oldObject, context, callback) {
        const action = context.restAction && context.restAction.crudType
        if (action === 'U' && oldObject.deadline !== newObject.deadline) newObject.numberOfRevisions +=1
        callback(null, newObject, oldObject)
    }
}

export const module_ = {
    object: 'Action',
    category: {
        path: 'dossier',
        icon: 'briefcase'
    },
    defaultSortBy: 'deadline',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'groupAndCompany', initiallyNotVisible: true},
            {path: 'project', display: 'fullName'},
            'type',
            'name',
            { path: 'responsible'}, //display: 'firstname'},
            'deadline',
            'status',
            'priority',
            {path: 'state', initiallyNotVisible: true},
            {path: 'numberOfRevisions', tKey: 'Révision(s)'}
        ],
        form: [
            {
                path: 'project',
                display: 'fullName',
                placeholder : 'Sélectionner le projet de l’action',
                filters: ['onlyUserInTeam'], //'onlyOngoingProspectiveProject'],
                fieldPath: ['id', 'fullName', 'team.id', 'subject.actionType'],
                subscriptions: {
                    onChange: (newValue, oldValue, { store }) => {
                        const projectActionTypes = _.get(newValue, 'type.actionType') || []
                        const actionTypeQuery = { actionTypes: projectActionTypes.map(o => o.id) }

                        store.dispatch(
                            generateFetchFieldListAction(
                                'm-K-action.Action_type',
                                store.getState,
                                {data: actionTypeQuery}
                            )
                        )

                        const responsibleQuery = { team: (newValue?.team || []).map(o => o.id) }

                        store.dispatch(
                            generateFetchFieldListAction(
                                'm-K-action.Action_responsible',
                                store.getState,
                                {data: responsibleQuery}
                            )
                        )
                    }
                }
            },
            {
                path: 'type',
                display: 'fullName',
                placeholder : 'sélectionner le type de l’action',
                filters: ['inProjectTypes'],
            },
            {path: 'name', required: true, placeholder : 'renseigner le nom de l’action'},
            { path: 'description', tKey: 'synthèse', type: 'richTextEditor', placeholder : 'Saisir une description synthétique de l’action' },
            {
                path: 'responsible',
                placeholder : 'Sélectionner le responsable de l’action',
                $default: (context) => {
                    return context?.user?.id ?
                        context?.user?.k ? [] : [context?.user?.id]
                        : []
                },
                filters: [
                    {
                        query: function(context) {
                            const team = _.get(context.data, 'team')
                            if (team) {
                                const teamIds = team.map(member => new global.ObjectID(member))
                                return { _id: {$in: teamIds} }
                            }
                            return {_id: null}
                        }
                    }
                ],
            },
            {
                path: 'deadline',
                startDate: moment().format('YYYY-MM-DD'),
                required: true,
            },
            { path: 'status', placeholder : 'Sélectionner le statut de l’action' },
            {path: 'priority', placeholder : 'Sélectionner le niveau de priorité de l’action'},
            {path: 'conversations', tKey: 'suivi'},
            {path: 'state', type: 'toggle', default: {id: 'actif'}}
        ]
    },
    filters: [
        {
            path: 'project',
            object: 'Project',
            display: 'fullName',
            client: true,
            clearable: true,
            placeholder: 'selectProject',
            default: {id: null},
            query: function(context) {
                const projectId = _.get(context.data, 'project.id')
                if (projectId)
                    return { project: new global.ObjectID(projectId) }
                return {}
            }
        },
        {
            path: 'statusAction',
            tKey: 'status',
            object: 'ActionStatus',
            display: 'name',
            client: true,
            type: 'tags',
            clearable: true,
            placeholder: 'selectActionStatus',
            default: [{id: 'ongoing'}, {id: 'todo'}],
            query: function(context) {
                const actionStatuses = _.get(context.data, 'statusAction')
                if (actionStatuses.length)
                    return { status: {$in: actionStatuses.map(o => o.id)} }
                return {}
            }
        }
    ]
}
